var formatter = function formatter(value, type) {
  if (type === 'currency') {
    return "\xA3".concat(value);
  }

  if (type === 'years') {
    return parseInt(value, 10) > 1 ? "".concat(value, " years") : "".concat(value, " year");
  }

  if (type === 'months') {
    return parseInt(value, 10) > 1 ? "".concat(value, " months") : "".concat(value, " month");
  }

  return value;
};

export default formatter;
//# sourceMappingURL=form-summary-formatter.js.map